import { Button } from "../Button";
import { Modal } from "../Modal";

interface LeaveConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function LeaveConfirmModal({
  isOpen,
  onClose,
  onConfirm,
}: LeaveConfirmModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Leave Room">
      <div className="space-y-4">
        <p style={{ color: "var(--color-text-primary)" }}>
          Are you sure you want to leave this room?
        </p>
        <div className="flex gap-4">
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2 font-bold transition-all duration-150 cursor-pointer"
            style={{
              backgroundColor: "var(--color-error)",
              color: "var(--color-surface)",
              border: "var(--neo-border-medium)",
              boxShadow: "var(--neo-shadow-md)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = "var(--neo-shadow-lg)";
              e.currentTarget.style.transform = "translate(-2px, -2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = "var(--neo-shadow-md)";
              e.currentTarget.style.transform = "translate(0, 0)";
            }}
            onMouseDown={(e) => {
              e.currentTarget.style.boxShadow = "var(--neo-shadow-sm)";
              e.currentTarget.style.transform = "translate(2px, 2px)";
            }}
            data-testid="leave-confirm-button"
          >
            Yes, Leave
          </button>
          <Button
            onClick={onClose}
            variant="secondary"
            className="flex-1"
            data-testid="leave-cancel-button"
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
}
